import MainLayout from '../../../components/Display/MainLayout';

function Home() {

  return (

    <MainLayout websiteLabel={"superadmin Collectif Node"}>
    </MainLayout>
  );
}

export default Home;
